/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const accountsRoutes = {
  path: '/accounts',
  component: Layout,
  redirect: '/accounts/users',
  name: 'accounts',
  alwaysShow: true,
  meta: {
    title: 'Accounts',
    icon: 'Operation',
    permissions: [
      'bank_view',
      'bank_check_view',
      'group_view',
      'ledger_view',
      'journal_view',
      'account_report_view',
    ],
  },
  children: [
    /** accounts managements */
    // Bank -- *khalif
    {
      path: 'banks',
      component: () => import('../views/bank/List'),
      name: 'BankList',
      meta: { title: 'bankList', icon: 'Memo', permissions: ['bank_view'] },
    },
    {
      path: 'bank/edit/:id(\\d+)',
      component: () => import('../views/bank/components/BankEdit'),
      name: 'EditBank',
      meta: {
        title: 'bankProfile',
        noCache: true,
        permissions: ['bank_edit'],
      },
      hidden: true,
    },
    {
      path: 'bank-cheque/list',
      component: () => import('../views/bank-cheque/List'),
      name: 'bankChequeList',
      meta: {
        title: 'Bank Cheque List',
        icon: 'Memo',
        permissions: ['bank_check_view'],
      },
    },
    {
      path: 'bank-cheque/view/:id(\\d+)',
      component: () => import('../views/bank-cheque/components/Edit'),
      name: 'bankChequeEdit',
      meta: {
        title: 'Bank Cheque View',
        icon: 'Memo',
        permissions: ['bank_check_edit'],
      },
      hidden: true,
    },
    {
      path: 'groups/list',
      component: () => import('../views/group/List'),
      name: 'groupList',
      meta: { title: 'groupList', icon: 'Memo', permissions: ['group_view'] },
    },
    {
      path: 'groups/edit/:id(\\d+)',
      component: () => import('../views/group/Edit'),
      name: 'groupUpdate',
      meta: {
        title: 'groupUpdate',
        icon: 'Memo',
        permissions: ['group_edit'],
      },
      hidden: true,
    },
    {
      path: 'groups/Create',
      component: () => import('../views/group/Create'),
      name: 'groupCreate',
      meta: {
        title: 'groupCreate',
        icon: 'Memo',
        permissions: ['group_add'],
      },
      hidden: true,
    },
    {
      path: 'parent-group/list',
      component: () => import('../views/parent-group/List'),
      name: 'parentGroupList',
      meta: {
        title: 'parentGroupList',
        icon: 'Memo',
        permissions: ['group_view'],
      },
      hidden: true,
    },

    {
      path: 'default-group/list',
      component: () => import('../views/default-group/List'),
      name: 'defaultGroupList',
      meta: {
        title: 'defaultGroupList',
        icon: 'Memo',
        permissions: ['group_view'],
      },
      hidden: true,
    },
    {
      path: 'ledgers/list',
      component: () => import('../views/ledger/List'),
      name: 'ledgerList',
      meta: {
        title: 'ledgerList',
        icon: 'Memo',
        permissions: ['ledger_view'],
      },
    },
    {
      path: 'ledgers/edit/:id(\\d+)',
      component: () => import('../views/ledger/Edit'),
      name: 'ledgerpUpdate',
      meta: {
        title: 'ledgerUpdate',
        icon: 'Memo',
        permissions: ['ledger_edit'],
      },
      hidden: true,
    },
    {
      path: 'ledgers/Create',
      component: () => import('../views/ledger/Create'),
      name: 'ledgerCreate',
      meta: {
        title: 'ledgerCreate',
        icon: 'Memo',
        permissions: ['ledger_add'],
      },
      hidden: true,
    },

    {
      path: 'journals/list',
      component: () => import('../views/journal/List'),
      name: 'journalList',
      meta: {
        title: 'journalList',
        icon: 'Memo',
        permissions: ['journal_view'],
      },
    },
    {
      path: 'journals/Create',
      component: () => import('../views/journal/Create'),
      name: 'journalCreate',
      meta: {
        title: 'journalCreate',
        icon: 'Memo',
        permissions: ['journal_add'],
      },
      hidden: true,
    },
    {
      path: 'journals/view/:id(\\d+)',
      component: () => import('../views/journal/View'),
      name: 'journalView',
      meta: {
        title: 'journalView',
        icon: 'Memo',
        permissions: ['journal_view'],
      },
      hidden: true,
    },
    {
      path: 'journals/edit/:id(\\d+)',
      component: () => import('../views/journal/Edit'),
      name: 'journalUpdate',
      meta: {
        title: 'journalUpdate',
        icon: 'Memo',
        permissions: ['journal_edit'],
      },
      hidden: true,
    },
    {
      path: 'reports',
      component: () => import('../views/accounts/Report'),
      name: 'accountsReport',
      meta: {
        title: 'Reports',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
    },
    {
      path: 'view/cost-center-report',
      component: () => import('../views/accounts/CostCenterReport'),
      name: 'viewCostCenterReport',
      meta: {
        title: 'viewCostCenterReport',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/cost-center-report/summery',
      component: () => import('../views/accounts/CostCenterReportSummery'),
      name: 'viewCostCenterReportSummery',
      meta: {
        title: 'viewCostCenterReportSummery',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/ledger-report',
      component: () => import('../views/accounts/LedgerReport'),
      name: 'viewLedgerReport',
      meta: {
        title: 'viewLedgerReport',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/trial-balance-report',
      component: () => import('../views/accounts/TrialBalanceReport'),
      name: 'viewTrialBalanceReport',
      meta: {
        title: 'View Trial Balance Report',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },

    {
      path: 'view/group-summary-report',
      component: () => import('../views/accounts/groupSummaryReport'),
      name: 'viewGroupSummaryReport',
      meta: {
        title: 'View Group Summary Report',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/profit-loss-report',
      component: () => import('../views/accounts/ProfitLossReport'),
      name: 'viewProfitLossReport',
      meta: {
        title: 'View Profit Loss Report',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/day-book-report',
      component: () => import('../views/accounts/DayBookReport'),
      name: 'viewDayBookReport',
      meta: {
        title: 'View day book Report',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/post-dated-cheque',
      component: () => import('../views/accounts/PostDatedCheque'),
      name: 'viewPostDatedCheque',
      meta: {
        title: 'View PostDatedCheque',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/balance-sheet',
      component: () => import('../views/accounts/BalanceSheet'),
      name: 'viewBalanceSheet',
      meta: {
        title: 'View Balance Sheet',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
    {
      path: 'view/receipt-payment-report',
      component: () => import('../views/accounts/ReceiptPaymentReport'),
      name: 'viewReceiptPaymentReport',
      meta: {
        title: 'Receipt & Payment Report',
        icon: 'Memo',
        permissions: ['account_report_view'],
      },
      hidden: true,
    },
  ],
};

export default accountsRoutes;
